import { Avatar, Box, Card, Grid2, styled, Typography, useTheme } from '@mui/material';
import { useContext } from 'react';
import { FaultsDashboardsContext } from '../../contexts';
import { AvaniCard } from '../Cards';

const AvaniStyledFaultsHeaderCard = styled(Card)(() => ({
  [`& `]: {
    borderRadius: '16px',
    padding: '16px',
    height: '216px',
    backgroundImage: 'url("/static/images/background/welcomebanner-BGR.png")',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat'
  }
}));

export const FaultsHeader = () => {
  const { lastVisitFaults, filteredFaults } = useContext(FaultsDashboardsContext);
  const theme = useTheme();

  return (
    <Grid2 container columns={5} mt={3} spacing={1}>
      <Grid2 size={{ xs: 5, lg: 3 }}>
        <AvaniStyledFaultsHeaderCard>
          <Typography variant="h1" sx={{ color: 'white', textAlign: 'center', paddingTop: '70px' }}>
            Faults Dashboard
          </Typography>
        </AvaniStyledFaultsHeaderCard>
      </Grid2>

      <Grid2 size={{ xs: 5, lg: 1 }}>
        <AvaniCard title={'Total Unresolved'}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Avatar
              sx={{
                bgcolor: theme.colors.avani.magenta,
                width: 64,
                height: 64,
                paddingTop: '6px',
                fontSize: '24px',
                marginTop: '18px'
              }}
            >
              {filteredFaults.reduce((acc, cur) => (!cur.isResolved ? acc + 1 : acc), 0)}
            </Avatar>
          </Box>
        </AvaniCard>
      </Grid2>
      <Grid2 size={{ xs: 5, lg: 1 }}>
        <AvaniCard title={'Last Visit Faults'}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-evenly' }}>
            <Box>
              <Avatar
                sx={{
                  bgcolor: theme.colors.avani.magenta,
                  width: 64,
                  height: 64,
                  paddingTop: '6px',
                  fontSize: '24px',
                  marginTop: '18px'
                }}
              >
                {lastVisitFaults.critical}
              </Avatar>
              <Typography variant="h4" sx={{ textAlign: 'center', padding: '18px 0' }}>
                Critical
              </Typography>
            </Box>
            <Box>
              <Avatar
                sx={{
                  bgcolor: theme.colors.avani.teal,
                  width: 64,
                  height: 64,
                  paddingTop: '6px',
                  fontSize: '24px',
                  marginTop: '18px'
                }}
              >
                {lastVisitFaults.regular}
              </Avatar>
              <Typography variant="h4" sx={{ textAlign: 'center', padding: '18px 0' }}>
                Regular
              </Typography>
            </Box>
          </Box>
        </AvaniCard>
      </Grid2>
    </Grid2>
  );
};
